import { RotateCw, Home, Sparkles } from "lucide-react";

/**
 * BlitzCompleteCard — shown after the reader clears all 10 cards of a
 * Revision Blitz micro-burst. Two forward actions: run another 10, or
 * return to the standard feed.
 */
export default function BlitzCompleteCard({ onRunAnother, onBackToFeed, weakCount = 0 }) {
  return (
    <div
      data-testid="blitz-complete"
      className="w-full h-full max-w-[720px] mx-auto flex items-center justify-center px-2 sm:px-4"
    >
      <div className="relative w-full rounded-2xl bg-[#1A2232] border border-[#26334D] overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.35)]">
        {/* Coral warmth from the top to signal a successful revision cycle */}
        <div
          aria-hidden
          className="absolute inset-x-0 top-0 h-24 pointer-events-none"
          style={{ background: "linear-gradient(180deg, rgba(232,90,42,0.18) 0%, rgba(232,90,42,0) 100%)" }}
        />
        <div className="relative p-6 sm:p-8">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#E85A2A]/50 bg-[#E85A2A]/12 px-3 py-1 text-[10.5px] font-semibold tracking-[0.16em] uppercase text-[#E85A2A]">
            <Sparkles className="h-3 w-3" aria-hidden />
            Blitz Complete
          </span>

          <h3
            className="mt-4 font-semibold tracking-tight text-[#F8FAFC] break-words"
            style={{ fontSize: "clamp(20px, 5.4vw, 28px)", lineHeight: 1.25 }}
          >
            <span aria-hidden className="mr-1">⚡</span>
            Blitz Complete! 10/10 cards revised.
          </h3>

          <p
            className="mt-3 text-[#94A3B8]"
            style={{ fontSize: "clamp(13.5px, 3.7vw, 15px)", lineHeight: 1.65 }}
          >
            Memory decay reversed. Spaced repetition loop closed.
          </p>

          {weakCount > 0 && (
            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#F2BD68]/40 bg-[#F2BD68]/10 px-3 py-1.5 text-[12px] font-semibold text-[#F2BD68]">
              {weakCount} weak spot{weakCount === 1 ? "" : "s"} revisited this round
            </div>
          )}

          <div className="mt-6 flex flex-col gap-3 w-full">
            <button
              type="button"
              onClick={onRunAnother}
              data-testid="blitz-run-another"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#E85A2A] text-[#F8FAFC] px-4 py-3 text-sm font-semibold hover:bg-[#C94A1D] active:scale-[0.98] transition-all shadow-[0_6px_18px_rgba(232,90,42,0.35)]"
            >
              <RotateCw className="h-4 w-4" aria-hidden />
              <span aria-hidden>⚡</span> Run Another 10 Cards
            </button>
            <button
              type="button"
              onClick={onBackToFeed}
              data-testid="blitz-back-to-feed"
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-[#26334D] bg-[#111622] text-[#F8FAFC] px-4 py-3 text-sm font-semibold hover:bg-[#232E45] transition-colors"
            >
              <Home className="h-4 w-4" aria-hidden />
              <span aria-hidden>🏠</span> Back to Main Feed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
